import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b0d42e6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "comment-info-box" }
const _hoisted_2 = { class: "user-info" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "publish-time" }

import {nextTick, ref, watch} from 'vue';
import {Cell, Image} from 'vant';
import defaultAvatar from '@/assets/img/defaultAvatar.png';


const __default__ = {
  name: 'Item'
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    commentInfo: null,
    showPopup: null,
    isHighlight: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  commentInfo: CommentDetail;
  showPopup:(commentId: string, userId: number) => void;
  isHighlight: boolean;
}



watch(() => props.isHighlight, () => {
  if (props.isHighlight) {
    nextTick(() => {// 不加 nextTick 取不到最新生成的 dom
      const highlightCell = document.getElementById('highlight-cell');
      // 一些低版本浏览器(尤其是安卓)不支持 behavior: 'smooth', 因此直接滚动不了
      highlightCell?.scrollIntoView({block: 'center'});
    });
  }
  // 新发表的评论, 是刚挂载的, 因此需要加 immediate
}, {immediate: true});

const commentRef = ref<HTMLParagraphElement>();
const isShowSpreadBtn = ref<boolean>(false);
const isOmit = ref<boolean>(true);
watch(() => commentRef.value?.scrollHeight, () => {
  if (commentRef.value && commentRef.value.scrollHeight! > commentRef.value.offsetHeight!) {
    isShowSpreadBtn.value = true;
  }
});

const handleSpread = () => {
  isShowSpreadBtn.value = false;
  isOmit.value = false;
};

const handleItemClick = () => {
  props.showPopup(props.commentInfo.commentNumber, props.commentInfo.userInfo?.userId || 0);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Cell), {
    id: __props.isHighlight? 'highlight-cell' : '',
    class: _normalizeClass(["cell-box", __props.isHighlight ? 'highlight-bg' : '']),
    onClick: handleItemClick
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Image), {
        round: "",
        class: "avatar",
        width: "30px",
        height: "30px",
        fit: "cover",
        src: __props.commentInfo.userInfo?.avatar || _unref(defaultAvatar)
      }, null, 8, ["src"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(__props.commentInfo.userInfo?.username), 1),
          _hoisted_3
        ]),
        _createElementVNode("p", {
          ref_key: "commentRef",
          ref: commentRef,
          class: _normalizeClass(isOmit.value ? 'omit-p' : '')
        }, _toDisplayString(__props.commentInfo.content), 3),
        _withDirectives(_createElementVNode("span", {
          class: "spread-btn",
          onClick: _withModifiers(handleSpread, ["stop"])
        }, "展开", 8, _hoisted_4), [
          [_vShow, isShowSpreadBtn.value]
        ]),
        _createElementVNode("span", _hoisted_5, _toDisplayString(__props.commentInfo.createTime), 1)
      ])
    ]),
    _: 1
  }, 8, ["id", "class"]))
}
}

})